module.exports = __webpack_public_path__ + "img/logo.5d1da16d.png";